<template>
  <tr class="clinic-appointment">
    <td class="clinic-appointment__date">{{ pretty_date }}</td>
    <td v-if="showclinic" class="clinic-appointment__clinic">{{ clinic_name }}</td>
    <td class="clinic-appointment__doctor">{{ doctor_name }}</td>
    <td class="clinic-appointment__doctor">{{ derived_by }}</td>
    <td class="clinic-appointment__appointment">
      {{ appointment_name }}
    </td>
    <td class="clinic-appointment__type">
      {{ product_type }}
    </td>
    <td class="clinic-appointment__category">
      {{ category_name }}
    </td>
    <td class="clinic-appointment__customer">
      <a target="_blank" :href="customer_link">{{ customer_name }}</a>
    </td>
    <td class="clinic-appointment__price">{{ appointment_price }}</td>
    <td class="clinic-appointment__done">{{ done }}</td>
    <td class="clinic-appointment__paid">{{ paid }}</td>
  </tr>
</template>

<script>
export default {
  props: {
    appointment: { required: true },
    clinics: { default: null },
    doctors: { default: null },
    showpaid: { default: null },
    categories: { default: null },
    orderby: { default: null },
    showclinic: { default: false },
    core: { default: false },
  },
  computed: {
    appointment_price() {
      return WabiDent.fmtMoney(this.appointment.price);
    },
    product_type() {
      if (!this.appointment.product) return "";
      return this.appointment.product.type == "product" ? "Producto" : "Ttto";
    },
    category_name() {
      if (!this.categories || !this.appointment.product.product_category_id)
        return "";

      return this.categories[this.appointment.product.product_category_id];
    },
    customer_name() {
      if (!this.appointment.customer) return "";
      return this.customer.full_name;
    },
    customer_link() {
      if (!this.appointment.customer) return "";
      return `/customer/${this.appointment.customer.id}/edit`;
    },
    pretty_date() {
      let d = this.appointment.created_at;
      switch (this.orderby) {
        case "done_at":
          d = this.appointment.done_at;
          break;
        case "paid_at":
          d = this.appointment.paid_at;
          break;
      }
      if (d) {
        return moment(d).toDate().toLocaleDateString();
      }
      return "-";
    },
    doctor_name() {
      if (!this.doctors) return "";
      let doc = this.doctors.find((doc) => {
        return doc.doctor.id == this.appointment.doctor_id;
      });

      if (!doc) return "";
      return doc.name;
    },
    derived_by() {
      if (!this.doctors) return "";
      let doc = this.doctors.find((doc) => {
        return doc.doctor.id == this.appointment.derived_by;
      });

      if (!doc) return "";
      return doc.name;
    },
    appointment_name() {
      let teeth = "";
      if (this.appointment.teeth && this.appointment.teeth.length > 0) {
        teeth = " (" + this.appointment.teeth.join(",") + ")";
      }

      return this.appointment.product.name + teeth;
    },
    customer_name() {
      if (!this.appointment.customer) return "";
      return this.appointment.customer.full_name;
    },
    clinic_name() {
      if (!this.clinics) return "";
      return this.clinics[this.appointment.clinic_id] || "";
    },
    done() {
      if (this.appointment.status == "done") return "Sí";
      return "No";
    },
    paid() {
      if (this.appointment.is_paid) return "Sí";
      return "No";
    },
    price() {
      if (this.appointment.price) {
        return window.WabiDent.fmtMoney(this.appointment.price);
      }
      return "";
    },
  },
};
</script>

<style lang="scss"></style>
